import { render, staticRenderFns } from "./CandidateProfileDetail.vue?vue&type=template&id=1fcf9716&scoped=true"
import script from "./CandidateProfileDetail.vue?vue&type=script&lang=js"
export * from "./CandidateProfileDetail.vue?vue&type=script&lang=js"
import style0 from "./CandidateProfileDetail.vue?vue&type=style&index=0&id=1fcf9716&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fcf9716",
  null
  
)

export default component.exports